module.exports = {
  CREATED: 'created',
  INCONSISTENT: 'inconsistent',
  PENDING: 'pending',
  PROCESSED: 'processed',
  RETRY: 'retry',
  DONE: 'done',
  FAILED: 'failed',
};
